import { FC } from "react";

import { TEXT_STYLE } from "./constants";

export const ContactAdminNotice: FC = () => (
  <div className={TEXT_STYLE}>
    Please contact your admin or{" "}
    <a
      className="text-stone-600 underline hover:text-stone-700 dark:text-stone-400 dark:hover:text-stone-500"
      href="mailto:support@vviinn.com"
    >
      support@vviinn.com
    </a>{" "}
    to add your user to your company’s plan.
  </div>
);
